// modules
import { createSelector } from 'reselect'

// utils
import { patientSelector } from 'src/store/modules/patient/selectors'

export const patientExternalDocuments$ = createSelector(
  patientSelector,
  ({ externalDocuments }) => externalDocuments.externalDocuments
)
